import { useEffect, useRef } from "react";

import { DRAWER_VIEW } from "@/constants/views";
import { useAppDispatch, useAppSelector } from "@/store";
import { openDrawer } from "@/store/slices/commonSlice";

/** Opens the real OTP login at startup when the tenant requires it. */
export default function CustomerLoginGate() {
  const dispatch = useAppDispatch();
  const shown = useRef(false);
  const timing = useAppSelector(
    (state) => state.settings.data.web_customer_login_timing,
  );
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const isStaff = useAppSelector((state) => state.auth.isStaff);
  const fetching = useAppSelector((state) => state.auth.fetchingCustomerInfo);
  const drawer = useAppSelector((state) => state.common.drawer);

  useEffect(() => {
    if (
      shown.current ||
      timing !== "STARTUP" ||
      isLoggedIn ||
      isStaff ||
      fetching ||
      drawer != null
    ) return;
    shown.current = true;
    dispatch(openDrawer(DRAWER_VIEW.VERIFICATION));
  }, [dispatch, drawer, fetching, isLoggedIn, isStaff, timing]);

  return null;
}
